import { Injectable } from '@angular/core';

import { MessageBoxButton } from '@reg/shared/message-box/message-box-button.model';
import { MessageBoxOptions } from '@reg/shared/message-box/message-box-options.model';

@Injectable()
export class MessageBoxService {
    public showYesNo: (title: string,
                       message: string,
                       callback: (isYes: boolean) => void,
                       options?: MessageBoxOptions) => void;
    public showOK: (title: string,
                    message: string,
                    callback?: (buttonId: string) => void,
                    options?: MessageBoxOptions) => void;
    public show: (title: string,
                  message: string,
                  buttons: MessageBoxButton[],
                  callback: (buttonId: string) => void,
                  options?: MessageBoxOptions) => void;
    public hide: () => void;
}
